import * as React from "react";
import { FormProvider } from "react-hook-form";
import { DialogContentText, Box, Typography, Stack } from "@mui/material";

import arrow from "../../../../styles/svg/arrow.svg";
import "./mergeBoard.scss";
import { useResponsive } from "../../../../hooks/useResponsive";
import Loader from "../../../../components/Loader";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { RFHTextField, RHFSelect } from "../../../../components/RFH";
import { useMergeBoardState } from "./hooks/useMergeBoardState";

export default function MergeBoard({
  open,
  close,
  currentBoard,
  admin = false,
}) {
  const isMobile = useResponsive("down", "md");
  const {
    canSelectTargetBoard,
    handleClose,
    handleMergeBoard,
    isPending,
    methods,
    selectedTargetBoardId,
    shouldShowWorkflowMapping,
    sourceBoardOptions,
    sourceWorkflowName,
    sourceWorkflowSteps,
    targetWorkflowSteps,
    targetBoardOptions,
  } = useMergeBoardState({
    admin,
    close,
    currentBoard,
  });

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <FormDialog
          open={open}
          handleClose={handleClose}
          title={"Merge Board"}
          handleSubmit={handleMergeBoard}
          buttonTxt={"Update"}
          width={513}
          disabled={!selectedTargetBoardId || isPending}
          cancelBtn={true}
          fullWidth={true}
        >
          <div>
            <div className="move-ticket-dialog-content">
              <DialogContentText className="move-ticket-dialog-contentText">
                As the board merges, all tasks will be moved to the target
                board.
              </DialogContentText>
            </div>
            <div className="move-ticket-form-dialogContent">
              <div
                className={
                  isMobile
                    ? "mobile-ticket-reasign-step-container"
                    : "ticket-reasign-step-container"
                }
              >
                <div
                  className={
                    isMobile
                      ? "mobile-current-target-board-name"
                      : "current-target-board-name"
                  }
                >
                  <p>
                    {sourceWorkflowName}
                  </p>
                  {admin ? (
                    <div className="initial-step">
                      <RHFSelect
                        sx={{
                          width: isMobile ? "100%" : "180px",
                        }}
                        className="mui-status-field"
                        required
                        name={"sourceBoard"}
                      >
                        {sourceBoardOptions.length > 0 ? (
                          sourceBoardOptions.map((option) => (
                            <CustomMenuItem
                              key={`source-${option?.board_id}`}
                              id={`source-${option?.board_id}`}
                              value={option?.board_id}
                            >
                              {option?.board_name}
                            </CustomMenuItem>
                          ))
                        ) : (
                          <CustomMenuItem>No boards Found</CustomMenuItem>
                        )}
                      </RHFSelect>
                    </div>
                  ) : (
                    <div className="initial-step">
                      <RFHTextField
                        name=""
                        className="mui-status-field"
                        disabled
                        value={currentBoard?.board_name ?? ""}
                      />
                    </div>
                  )}
                </div>

                <img src={arrow} alt="" />
                <div
                  className={
                    isMobile
                      ? "mobile-current-target-board-name"
                      : "current-target-board-name"
                  }
                >
                  <p>Target board</p>
                  <div className="initial-step">
                    <RHFSelect
                      className="mui-status-field merge-board-field"
                      required
                      name={"targetStep"}
                      disabled={!canSelectTargetBoard}
                    >
                      {targetBoardOptions.length > 0 ? (
                        targetBoardOptions.map((option) => (
                          <CustomMenuItem
                            key={`target-${option.board_id}`}
                            id={`target-${option.board_id}`}
                            value={option.board_id}
                          >
                            {option.board_name}
                          </CustomMenuItem>
                        ))
                      ) : (
                        <CustomMenuItem>No boards Found</CustomMenuItem>
                      )}
                    </RHFSelect>
                  </div>
                </div>
              </div>
              {shouldShowWorkflowMapping && (
                <Box className="mt-4">
                  <Typography className="weight-700 size-16 text-color">
                    Task Reassignment Step
                  </Typography>
                  <Stack spacing={1}>
                    {sourceWorkflowSteps.map((step) => (
                      <Box
                        className="board-workflow-change-item"
                        key={`board-workflow-${step.workflow_step_id}`}
                      >
                        <RFHTextField
                          sx={{ width: "40%", backgroundColor: "white" }}
                          className="mui-status-field"
                          disabled={true}
                          defaultValue={step?.status || ""}
                          name={`prev_step_${step.workflow_step_id}`}
                        />
                        <img src={arrow} alt="to" className="arrow-img" />

                        <RHFSelect
                          sx={{ width: "40%", backgroundColor: "white" }}
                          className="mui-status-field"
                          required
                          id={`${step.workflow_step_id}`}
                          name={`workflow_step_exchange_id.${step.workflow_step_id}`}
                          defaultValue={targetWorkflowSteps[0]?.workflow_step_id}
                        >
                          {targetWorkflowSteps.map((option) => (
                            <CustomMenuItem
                              key={`workflow-option-${option.workflow_step_id}`}
                              id={`workflow-option-id-${option.workflow_step_id}`}
                              value={option.workflow_step_id}
                              className="uppercase"
                            >
                              {option.status}
                            </CustomMenuItem>
                          ))}
                        </RHFSelect>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              )}
            </div>
          </div>
          {isPending && (
            <div className="popup-loader">
              <Loader color={"black"} />
            </div>
          )}
        </FormDialog>
      </FormProvider>
    </React.Fragment>
  );
}
